window.addEventListener("scroll", () => {
  const allParallax = document.getElementsByClassName("parallax-item");
  for (let i = 0; i < allParallax.length; i++) {
    // Adjust the factor to slow down the parallax effect
    const factor = 0.25; // Adjust this value to control the speed
    allParallax[i].style.transform =
      "translateY(calc(160px - " +
      (window.scrollY * factor * i) / allParallax.length +
      "px))";
  }
});

// Select all elements with the class 'animation'
const the_animation = document.querySelectorAll(".animation");

// Create a new Intersection Observer
const observer = new IntersectionObserver(
  (entries) => {
    // For each entry
    entries.forEach((entry) => {
      // Check if the element has the 'instant-load' class
      const hasInstantLoad = entry.target.classList.contains("instant-load");
      // If the entry is intersecting (visible in the viewport)
      if (entry.isIntersecting || hasInstantLoad) {
        // Add the 'scroll-animation' class to the target element
        entry.target.classList.add("scroll-animation");
      } else {
        // If the entry is not intersecting (not visible), remove the 'scroll-animation' class
        // entry.target.classList.remove("scroll-animation");
        // if (!hasInstantLoad) {
        //   entry.target.classList.remove("scroll-animation");
        // }
      }
    });
  },
  // Set the threshold for the Intersection Observer to 0.5,
  // meaning at least 35% of the element needs to be visible for it to be considered intersecting
  { threshold: 0 }
);

// For each element in the 'the_animation' NodeList
for (let i = 0; i < the_animation.length; i++) {
  const elements = the_animation[i];

  // Start observing the element for intersection with the viewport
  observer.observe(elements);
}

jQuery(document).ready(function () {
  function enableDragging() {
    jQuery('.image-container').each(function () {
      var $container = jQuery(this);
      var $img = $container.find('img');
      var $zoomInButton = $container.find('.zoom-in');
      var $zoomOutButton = $container.find('.zoom-out');

      var scale = 1;
      var scaleStep = 0.5;
      var zoomOutStep = 0.5;
      var maxScale = 3;
      var minScale = 1;
      var isDragging = false;
      var startX, startY, initialX, initialY;
      var originalLeft = 0;
      var originalTop = 0;

      $zoomInButton.on('click', function () {
        if (scale < maxScale) {
          scale += scaleStep;
          $img.css({
            'transform': 'scale(' + scale + ')',
            'transform-origin': 'center center'
          });
        }
      });

      $zoomOutButton.on('click', function () {
        if (scale > minScale) {
          scale -= zoomOutStep;
          if (scale < minScale) scale = minScale;
          $img.css({
            'transform': 'scale(' + scale + ')',
            'transform-origin': 'center center'
          });
          if (scale === minScale) {
            $img.css({
              'left': originalLeft + 'px',
              'top': originalTop + 'px'
            });
          }
        }
      });

      $img.on('mousedown touchstart', function (e) {
        if (scale > minScale) {
          isDragging = true;
          startX = e.type === 'touchstart' ? e.originalEvent.touches[0].pageX : e.pageX;
          startY = e.type === 'touchstart' ? e.originalEvent.touches[0].pageY : e.pageY;
          initialX = parseFloat($img.css('left')) || 0;
          initialY = parseFloat($img.css('top')) || 0;
          $img.css('cursor', 'grabbing');
          e.preventDefault();
        }
      });

      jQuery(document).on('mousemove touchmove', function (e) {
        if (isDragging) {
          var currentX = e.type === 'touchmove' ? e.originalEvent.touches[0].pageX : e.pageX;
          var currentY = e.type === 'touchmove' ? e.originalEvent.touches[0].pageY : e.pageY;
          var dx = currentX - startX;
          var dy = currentY - startY;
          $img.css({
            left: initialX + dx + 'px',
            top: initialY + dy + 'px'
          });
          e.preventDefault();
        }
      });

      jQuery(document).on('mouseup touchend', function () {
        isDragging = false;
        $img.css('cursor', 'grab');
      });

      $img.css('cursor', 'grab');
      originalLeft = parseFloat($img.css('left')) || 0;
      originalTop = parseFloat($img.css('top')) || 0;
    });
  }

  function disableDragging() {
    jQuery('.image-container').each(function () {
      var $container = jQuery(this);
      var $img = $container.find('img');
      var $zoomInButton = $container.find('.zoom-in');
      var $zoomOutButton = $container.find('.zoom-out');

      $zoomInButton.off('click');
      $zoomOutButton.off('click');
      $img.off('mousedown touchstart');
      jQuery(document).off('mousemove touchmove');
      jQuery(document).off('mouseup touchend');
      $img.css('cursor', '');
    });
  }

  function checkScreenSize() {
    if (window.innerWidth > 992) {
      enableDragging();
    } else {
      disableDragging();
    }
  }

  jQuery(window).on('resize', checkScreenSize);
  checkScreenSize();
});

jQuery(document).ready(function ($) {
  var $toggler = $('.navbar-toggler');
  var $offcanvas = $('.offcanvas');
  var $smnav = $('.smnav');

  $toggler.click(function (e) {
    $(this).toggleClass('active');
    // Add 'active' to .smnav only when opening
    if ($(this).hasClass('active')) {
      $smnav.addClass('active');
    }
  });

  $(document).click(function (e) {
    if (
      !$toggler.is(e.target) && $toggler.has(e.target).length === 0 &&
      !$offcanvas.is(e.target) && $offcanvas.has(e.target).length === 0
    ) {
      $toggler.removeClass('active');
      $smnav.removeClass('active');
    }
  });
});
